import {
  GESTION_OPERATIVA_GET_PERITAJE_BEGIN,
  GESTION_OPERATIVA_GET_PERITAJE_SUCCESS,
  GESTION_OPERATIVA_GET_PERITAJE_FAILURE,
  GESTION_OPERATIVA_GET_PERITAJE_DISMISS_ERROR,
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case GESTION_OPERATIVA_GET_PERITAJE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getPeritajePending: true,
        getPeritajeError: null,
      }

    case GESTION_OPERATIVA_GET_PERITAJE_SUCCESS:
      // The request is success
      const peritaje  = action.data.peritaje
      let peritaciones = state.peritaciones
      if (!peritaciones) 
        peritaciones = []
        
        peritaciones[peritaje.servicePatent] = peritaje 
        peritaciones[peritaje.servicePatent] = {...peritaciones[peritaje.servicePatent], verification_type: action.data.peritajeQuoteVerification.verification_type}

      return {
        ...state,
        peritaciones,
        getPeritajePending: false,
        getPeritajeError: null,
      }

    case GESTION_OPERATIVA_GET_PERITAJE_FAILURE:
      // The request is failed
      return {
        ...state,
        getPeritajePending: false,
        getPeritajeError: action.data.error,
        patenteError: action.data.patenteError,
        patenteCodeError: action.data,
      }
      
      case GESTION_OPERATIVA_GET_PERITAJE_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
        getPeritajePending: false,
        getPeritajeError: null,
      }

    default:
      return state
  }
}
